import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import HomeOutlined from "@mui/icons-material/HomeOutlined";
import LayersOutlined from "@mui/icons-material/LayersOutlined";
import EqualizerOutlined from "@mui/icons-material/EqualizerOutlined";
import DnsOutlined from "@mui/icons-material/DnsOutlined";
import PeopleAltOutlined from "@mui/icons-material/PeopleAltOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { ShieldOutlined, MenuBookOutlined } from "@mui/icons-material";

const withFilteredProps = (WrappedComponent) => {
  return ({ isActive, ...props }) => {
    return <WrappedComponent {...props} />;
  };
};

const FilteredNavLink = withFilteredProps(NavLink);

const StyledNavLink = styled(FilteredNavLink)(({ theme, isActive }) => ({
  color: theme.palette.text.navigation,
  fontSize: "1.2rem",
  padding: theme.spacing(1),
  textDecoration: "none",
  display: "flex",
  alignItems: "center",
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  transition: "all 0.3s ease",
  fontFamily: theme.typography.subtitle1.fontFamily,
  fontWeight: theme.typography.subtitle1.fontWeight,

  "&::before": {
    content: '""',
    width: "40px",
    height: "40px",
    backgroundColor: theme.palette.primary.main,
    position: "absolute",
    left: "-45px",
    top: "50%",
    transform: "translateY(-50%)",
    borderRadius: "15px",
    opacity: isActive ? "1" : "0",
    transition: "all 0.3s ease",
  },

  "&:hover::before": {
    opacity: 1,
    left: "-42px",
  },

  //   "&:hover": {
  //     backgroundColor: "rgba(255, 255, 255, 0.1)",
  //     color: theme.palette.primary.main,
  //   },

  // Active state styling
  ...(isActive && {
    color: theme.palette.primary.main,
    // backgroundColor: `${theme.palette.primary.main}20`, // 20% opacity
  }),
}));

const NavLinkText = styled("span")(({ theme, collapsed }) => ({
  opacity: collapsed ? "0" : "1",
  visibility: collapsed ? "hidden" : "visible",
  transition: "opacity 0.3s ease, visibility 0s ease",
  width: collapsed ? "0px" : "auto",
  whiteSpace: "nowrap",
  overflow: "hidden",
}));

const StyledSpacerDiv = styled("div")(({ theme }) => ({
  display: "inline-block",
  marginLeft: theme.spacing(1),
}));

// `...rest` so callers can stamp the link with the data-testid / aria-label
// pair every interactive element gets (e2e/README.md). Everything here lands on
// the rendered <a>.
const ParentNavLink = ({ to, collapsed, children, ...rest }) => {
  const location = useLocation();
  const parentLocation = to.split("/")[1];
  const [isActive, setIsActive] = useState(
    location.pathname.includes(parentLocation),
  );

  useEffect(() => {
    setIsActive(location.pathname.split("/")[1].includes(parentLocation));
  }, [location]);

  return (
    <StyledNavLink isActive={isActive} to={to} {...rest}>
      {children === "FOUNDATION" && <HomeOutlined fontSize="large" />}
      {children === "UPKEEP" && <LayersOutlined fontSize="large" />}
      {children === "REPORTS" && <EqualizerOutlined fontSize="large" />}
      {children === "HISTORY" && <DnsOutlined fontSize="large" />}
      {children === "CONTACTS" && <PeopleAltOutlined fontSize="large" />}
      {children === "ADMIN" && <ShieldOutlined fontSize="large" />}
      {children === "BOOKKEEPING" && <MenuBookOutlined fontSize="large" />}
      {children === "SETTINGS" && <SettingsOutlinedIcon fontSize="large" />}
      <StyledSpacerDiv />
      <NavLinkText collapsed={collapsed}>{children}</NavLinkText>
    </StyledNavLink>
  );
};

export default ParentNavLink;
